let apiUrl;
let frontUrl;
export const clientBaseUrl = 'https://www.yonelajohannes.engineer/'
if (process.env.NODE_ENV === 'production') {
  apiUrl = 'https://myblog-707i.onrender.com/api/';
  frontUrl = '';
} else {
  apiUrl = 'http://localhost:4000/api';
  frontUrl = 'http://localhost:3000';
}

export const baseUrl = apiUrl;
export {
  frontUrl
}
